<div class="form-group" *transloco="let t; read: 'templates.createPage'" [formGroup]="form" [class.disabled-form]="disabled$ | async">
  @if (!isSingleDestinationType) {
    <label class="col-form-label position-relative">
      {{ t('destinationUrl') }}
      <span *ngIf="isRequired" class="text-danger">*</span>
      <ng-container *ngTemplateOutlet="labelTooltip"></ng-container>
    </label>
    <app-radio-group
      *ngIf="showDestinationOptions && radioButtons.length"
      formControlName="destinationType"
      groupName="destinationType"
      [items]="radioButtons"
    ></app-radio-group>
  }

  <ng-container [ngSwitch]="destinationTypeValue">
    <!-- TemplateDestinationType.Widget -->
    <ng-container *ngSwitchCase="TemplateDestinationType.Widget">
      <lib-dropdown
        bindValue="widgetType"
        bindLabel="label"
        [label]="isSingleDestinationType ? t('marketingApps') : ''"
        [control]="form.controls.widgetType"
        [items]="marketingAppOptions"
        [placeholder]="t('marketingApp')"
        [clearable]="true"
        [isRequired]="isSingleDestinationType"
        [appendOptionsToBody]="true"
      ></lib-dropdown>

      <div class="row" *ngIf="isWidgetDigitalCoupon">
        <div class="form-group coupon-container" *transloco="let tc; read: 'common'">
          <app-coupon-input
            formControlName="couponId"
            [disableEmpty]="locationCouponsList === null"
            [couponsList]="locationCouponsList"
            [displayInactiveCoupon]="true"
          ></app-coupon-input>
        </div>
      </div>
    </ng-container>

    <!-- TemplateDestinationType.Url -->
    <ng-container *ngSwitchCase="TemplateDestinationType.Url">
      <app-checkbox
        *ngIf="allowSeparateUrl && isRequired"
        size="lg"
        [control]="form.controls.separateUrl"
        [inlineLabel]="t('separateUrl')"
        [isSlider]="true"
      ></app-checkbox>

      <div *ngIf="isRequired" class="form-group">
        <app-safe-url-form-control
          formControlName="navigateQrCodeUrl"
          [label]="showFormLabels ? t('qrDestinationUrl') : ''"
          [mark]="true"
          [isHideTooltip]="true"
          [validators]="navigateQrCodeUrlValidators"
          [makeTouched]="makeUrlTouched$ | async"
        >
        </app-safe-url-form-control>
      </div>

      <app-safe-url-form-control
        *ngIf="!isRequired || isSeparateUrl"
        formControlName="navigateUrl"
        [label]="showFormLabels ? t('clickDestinationUrl') : ''"
        [placeholder]="t('clickDestinationUrlPlaceholder')"
        [mark]="isSeparateUrl"
        [isHideTooltip]="true"
        [validators]="navigateUrlValidators"
      ></app-safe-url-form-control>
    </ng-container>
  </ng-container>
</div>


<ng-template #labelTooltip>
  <div
    class="font-size-18 widget-icon-tooltip"
    [ngbTooltip]="urlHelpTooltip"
    #tt="ngbTooltip"
    container="body"
    (mouseout)="tt.close()"
    triggers="click:blur"
  >
    <i class="bx bx-question-mark mb-0 text-info"></i>

    <ng-template #urlHelpTooltip>
      <div class="text-start">{{ "common.error.secureUrl" | transloco : { field: ('templates.createPage.destinationUrl' | transloco) } }}</div>
    </ng-template>
  </div>
</ng-template>
